/* eslint-disable import/no-anonymous-default-export */
import * as actionType from "../actions/actionType";
import { cloneDeep } from "lodash";

const defaultEditManagement = {
  name: "",
};

const initialState = {
  tableList: [],
  loading: false,
  pageNum: 1,
  pageSize: 20,
  tableListTotal: 0,
  editLoading: false,
  editInfo: cloneDeep(defaultEditManagement),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.SCORE_CONFIG_UPDATE_STATE:
      return {
        ...state,
        ...action.payload.obj,
      };
    case actionType.SCORE_CONFIG_UPDATE_EDIT_STATE:
      return {
        ...state,
        editInfo: {
          ...state.editInfo,
          ...action.payload.obj,
        },
      };

    case actionType.CLEAN_SCORE_CONFIG_DETAIL:
      return {
        ...state,
        editInfo: cloneDeep(defaultEditManagement),
      };

    default:
      return state;
  }
};
